import * as React from 'react';
import { css, cx } from 'emotion';

const image = css`
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: opacity 1s ease;
`;

const imageFadeIn = css`
  opacity: 1;
`;

interface LazyImageProps {
  alt: string;
  src: string;
  height: number;
  width: number;
  onClick?: (e: any) => void;
}

interface LazyImageState {
  placeholderStyle?: Object;
  hasLoaded: boolean;
}

class LazyImage extends React.PureComponent<LazyImageProps, LazyImageState> {
  state = {
    hasLoaded: false,
  };

  componentDidMount() {
    this.handleImageNotLoaded();
  }

  handleImageLoaded = () => {
    this.setState(prevState => ({
      hasLoaded: true,
    }));
  };

  handleImageNotLoaded = () => {
    this.setState(prevState => ({
      hasLoaded: false,
    }));
  };

  handleImageError = () => {
    console.log('error');
    this.handleImageNotLoaded();
  };

  handleImageClick = (e: any) => {
    e.preventDefault();
    const { onClick } = this.props;
    if (onClick) {
      onClick(e);
    }
  };

  render() {
    const { height, width, onClick } = this.props;
    const { hasLoaded } = this.state;
    const paddingBottom = `${(height / width) * 100}%`;
    const imageContainer = {
      display: 'block',
      position: 'relative',
      height: 0,
      paddingBottom,
    } as any;
    if (onClick) {
      imageContainer.cursor = 'pointer';
    }

    const imageLoaded = hasLoaded ? cx(image, imageFadeIn) : image;
    return (
      <div className={css(imageContainer)}>
        <img
          className={imageLoaded}
          alt={this.props.alt}
          src={this.props.src}
          onError={this.handleImageError}
          onLoad={this.handleImageLoaded}
          onClick={this.handleImageClick}
        />
      </div>
    );
  }
}

export default LazyImage;
